var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organism-site-management',{attrs:{"fields":_vm.fields,"items":_vm.siteList,"filter":_vm.filter},on:{"onChangeFilter":_vm.handleChangeFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }